import { CSSProperties, useState } from "react";
import { motion } from "../../alias";
import { useInterval } from "../hook/useInterval";
import { CustomNotification } from "./Notification";
import { useNotifications } from "./NotificationContext";
import { XProgressBar } from "./XProgressBar";

export const XNotification = ({
  notification,
  style,
}: {
  notification: CustomNotification;
  style?: CSSProperties;
}) => {
  const { remove } = useNotifications();
  const [percent, setPercent] = useState(0);
  const [left, setLeft] = useState(0);
  const { content, expireAt, createdAt, id } = notification;
  const duration = expireAt.getTime() - createdAt.getTime();
  useInterval(
    () => {
      if (duration <= 0) return;
      const elapsed = new Date().getTime() - createdAt.getTime();
      let percent = elapsed / duration;
      percent = Math.max(0, Math.min(percent, 1));
      setPercent(percent);
    },
    100,
    [duration, setPercent, createdAt]
  );

  if (duration <= 0) return null;

  const disappearedLeft = 120;
  const animationDuration = 1000;
  const finalLeft = percent === 1 ? disappearedLeft : left;

  if (content === null) return null;

  return (
    <motion.div
      onClick={() => {
        setLeft(disappearedLeft);
        setTimeout(() => {
          remove([notification.id]);
        }, animationDuration);
      }}
      layoutId={id}
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        left: `${finalLeft}%`,
        transform: `left ${animationDuration}ms ease-in-out`,
        pointerEvents: "auto",
        ...style,
      }}
    >
      <div style={{ pointerEvents: "none" }}>{content}</div>
      <XProgressBar percent={percent} />
    </motion.div>
  );
};
